import { BACKEND_BASE_URL } from "../config/app.config";
import { httpPost } from "./http.service";

export type StockChatRequest = {
  question: string;
  forceRefresh?: boolean;
  contextTickers?: string[];
};

export type StockChatResponse = {
  answer: string;
  answer_raw: string;
  chart?: any;
  charts?: any[];
  plan?: any;
  cached?: boolean;
  resolvedTickers?: Array<{ ticker: string }>;
  meta?: {
    usedTicker?: string | null;
    lastUpdated?: string | null;
    stale?: boolean;
    confidence?: "high" | "medium" | "low";
    suggestions?: string[];
    needsPeriod?: boolean;
    fallback?: "online" | null;
  };
};

const CHATBOT_URL = `${BACKEND_BASE_URL}/api/stock-chat/query`;

export const submitStockChatQuery = async (
  payload: StockChatRequest
): Promise<StockChatResponse> => {
  const response = await httpPost(CHATBOT_URL, payload);
  return response?.data;
};
